/* eslint-disable camelcase */
import React from 'react';
import { LazyLink } from '../../../../../../../slices/atoms';

import { TinyNavBarItem, TinyNavBarHiringLink, TinyNavBarEndDivider } from '../TinyTopNavStyles';

const TinyTopNavLinks = data => {
  const { tiny_navigation_links } = data.navigation;

  return (
  <>
    <TinyNavBarHiringLink
      renderAs={LazyLink}
      url="https://www.digitalocean.com/careers/"
      >We're Hiring!
    </TinyNavBarHiringLink>
    <TinyNavBarEndDivider>//</TinyNavBarEndDivider>
    { tiny_navigation_links.map(item => (
    <TinyNavBarItem
      renderAs={LazyLink}
      href={item.tiny_navigation_link.url}
      url={item.tiny_navigation_link.url}
      rel={item.tiny_link_rel === 'nofollow' ? 'nofollow' : null}
    >
      {item.tiny_navigation_text}
    </TinyNavBarItem>
    ))
    }
  </>
  )
};

export default TinyTopNavLinks;
